import React from 'react';
import ProductList from '../../components/ProductList';

const ProductListPage: React.FC = () => {
  return (
    <ProductList />
  );
};

export default ProductListPage;
